import { Button, ButtonProps, Flex } from "@mantine/core";
import CustomSelect from "../common/Inputs/CustomSelect";
import dayjs from "dayjs";
import { useCallback, useEffect } from "react";
import { Views } from "react-big-calendar";
import { useAuth } from "../../context/AuthContext";
import ChevronLeftIcon from "../common/Icons/ChevronLeft";
import styled from "styled-components";
import ChevronRightIcon from "../common/Icons/ChevronRight";

const LOCAL_STORAGE_KEYS = {
  DEPARTMENT: "calendar_selected_department",
  ROLE: "calendar_selected_role",
};

const CalendarFilters = ({
  view,
  setView,
  selectedDepartment,
  setSelectedDepartment,
  selectedRole,
  setSelectedRole,
  date,
  setDate,
}: any) => {
  const { departmentSelectData, roleSelectData } = useAuth();

  useEffect(() => {
    const storedDepartment = localStorage.getItem(
      LOCAL_STORAGE_KEYS.DEPARTMENT
    );
    const storedRole = localStorage.getItem(LOCAL_STORAGE_KEYS.ROLE);

    if (storedDepartment) {
      const foundDepartment = departmentSelectData?.find(
        (d: any) => d.value === storedDepartment
      );
      if (foundDepartment) setSelectedDepartment(foundDepartment.value);
    }

    if (storedRole) {
      const foundRole = roleSelectData?.find(
        (r: any) => r.value === storedRole
      );
      if (foundRole) setSelectedRole(foundRole);
    }
  }, [departmentSelectData, roleSelectData]);

  const handleDepartmentChange = (value: any) => {
    setSelectedDepartment(value);
    localStorage.setItem(LOCAL_STORAGE_KEYS.DEPARTMENT, value);
  };

  const handleRoleChange = (value: any) => {
    const selected = roleSelectData.find((r: any) => r.value === value);
    setSelectedRole(selected);
    if (selected) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.ROLE, selected.value);
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.ROLE);
    }
  };

  const onNextClick = useCallback(() => {
    if (view === Views.WEEK) setDate(dayjs(date).add(1, "w"));
    if (view === Views.MONTH) setDate(dayjs(date).add(1, "M"));
  }, [view, date]);

  const onPrevClick = useCallback(() => {
    if (view === Views.WEEK) setDate(dayjs(date).subtract(1, "w"));
    if (view === Views.MONTH) setDate(dayjs(date).subtract(1, "M"));
  }, [view, date]);

  return (
    <Flex align={"center"} gap={12}>
      <CustomSelect
        value={selectedDepartment}
        placeholder="Departman"
        searchable={false}
        data={departmentSelectData}
        onChange={handleDepartmentChange}
        w={160}
        h={40}
        allowDeselect={false}
      />
      <CustomSelect
        value={selectedRole?.value}
        placeholder="Rol"
        searchable={false}
        data={roleSelectData}
        onChange={handleRoleChange}
        w={160}
        h={40}
        allowDeselect={false}
      />
      <DateSelectWrapper>
        <ChevronWrapper onClick={onPrevClick}>
          <ChevronLeftIcon size={20} />
        </ChevronWrapper>
        <DateTitle>{dayjs(date).format("YYYY MMMM")}</DateTitle>
        <ChevronWrapper onClick={onNextClick}>
          <ChevronRightIcon size={20} />
        </ChevronWrapper>
      </DateSelectWrapper>
      <CustomSelect
        value={view}
        searchable={false}
        data={[
          {
            value: Views.WEEK,
            label: "Haftalık",
          },
          {
            value: Views.MONTH,
            label: "Aylık",
          },
        ]}
        onChange={setView}
        w={160}
        h={40}
        allowDeselect={false}
      />
    </Flex>
  );
};

export default CalendarFilters;

const ChevronWrapper = styled(Button)<ButtonProps | any>`
  background: none;
  border: none;
  &: hover {
    background: none;
  }
`;

const DateTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #111827;
  cursor: default;
`;

const DateSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 274px;
  height: 44px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
`;
